import "./RollingTomato.scss"

function RollingTomato() {
  return <div className="RollingTomato" />
}
export default RollingTomato
